var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "fm-step-progress",
      attrs: {
        role: "list",
        "aria-label": `Step ${_vm.currentStep + 1} of ${_vm.steps.length}`,
      },
    },
    _vm._l(_vm.steps, function (step, idx) {
      return _c(
        "div",
        {
          key: step,
          class: {
            "fm-step": true,
            "fm-step--completed": idx < _vm.currentStep,
            "fm-step--active": idx === _vm.currentStep,
          },
          attrs: {
            role: "listitem",
            "data-label": step,
            "aria-current": idx === _vm.currentStep ? "step" : undefined,
          },
        },
        [
          idx > 0 ? _c("div", { staticClass: "fm-step__connector" }) : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "fm-step__bubble" }, [
            idx < _vm.currentStep
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 16 16",
                      fill: "currentColor",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.86-8.736z",
                      },
                    }),
                  ]
                )
              : _c("span", { attrs: { "aria-hidden": "true" } }, [
                  _vm._v(_vm._s(idx + 1)),
                ]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "fm-step__label" }, [_vm._v(_vm._s(step))]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }